import * as React from "react";
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { SelectField } from "src/common/components";

const useStyles = makeStyles((theme: any) => ({
  dropDownContainer: {
    "&:before": {
      border: "none"
    },
    border: "1px solid #bdbdbd",
    display: "flex" as "flex"
  },
  invalid: {
    "& > button": {
      background: "#ffebee"
    }
  }
}));

const emptyFn = (): void => void 0;

interface IOwnProps {
  options: string[];
  placeholder?: string;
  readOnly?: boolean;
  onChange?: (newValue: number) => void;
  invalid?: boolean;
  value: number | null;
}

export const DropDownQuestion = ({
  options,
  placeholder,
  readOnly = false,
  onChange,
  invalid = false,
  value
}: IOwnProps) => {
  const classes = useStyles();
  const handleChange = React.useCallback(
    (newValue: string) => {
      if (onChange) {
        onChange(parseInt(newValue, 10));
      }
    },
    [onChange]
  );

  const selectOptions = React.useMemo(() => {
    return options.map((optionLabel, index) => {
      return {
        label: optionLabel,
        value: index.toString()
      };
    });
  }, [options]);

  const {
    t,
    i18n: { language: lng }
  } = useTranslation();

  const displayPlaceholder = React.useMemo(() => {
    return placeholder ? placeholder : t(`feedback.dropDown.chooseValue`);
  }, [placeholder, lng]);

  const selectClassName = React.useMemo(() => {
    const classNames = ["dropdown"];
    if (invalid) {
      classNames.push(classes.invalid);
    }
    return classNames.join(" ");
  }, [invalid]);

  return (
    <SelectField
      className={selectClassName}
      name="dropdown"
      setFieldValue={emptyFn}
      options={selectOptions}
      label={displayPlaceholder}
      value={typeof value === "number" ? value.toString() : undefined}
      disabled={readOnly}
      onChange={handleChange}
    />
  );
};
